import { SegmentSelect } from '@/design-system/components/buttons/segmentSelect/SegmentSelect';
import { UniNativeModal } from '@/design-system/components/modal/nativeModal/UniNativeModal';
import { UniTabView } from '@/design-system/components/tabs';
import { NoAnimationTabView } from '@/design-system/components/tabs/NoAnimationTabView';
import { SxProp, View } from 'dripsy';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MyEarningsNative, MyEarningsNativeProps } from './myEarnings/MyEarningsNative';
import { OverviewNative, OverviewNativeProps } from './overview/OverviewNative';

interface AnalysisProps {
  overviewProps: OverviewNativeProps;
  myEarningsProps: MyEarningsNativeProps;
  onBack: () => void;
}

export const Analysis: React.FC<AnalysisProps> = ({ overviewProps, myEarningsProps, onBack }) => {
  const { t } = useTranslation('earn');
  const [tabIndex, setTabIndex] = useState(0);
  const tabs = [
    {
      title: 'Assets',
      name: t('earn-invest::glossary.assets')
    },
    {
      title: 'My Earnings',
      name: t('earn-invest::glossary.my-earnings')
    }
  ];

  return (
    <UniNativeModal title={t('earn-invest::glossary.portfolio')} onBack={onBack}>
      <View sx={styles.container}>
        {/* Button for Changing Tab */}
        <SegmentSelect data={tabs.map((tab, i) => ({ labelKey: tab.name, value: i }))} value={tabIndex} onValueChange={setTabIndex} />
        {/* Tab Content */}
        <View sx={styles.contentContainer}>
          {tabIndex === 0 ? <OverviewNative {...overviewProps} /> : null}
          {tabIndex === 1 ? <MyEarningsNative {...myEarningsProps} /> : null}
        </View>
      </View>
    </UniNativeModal>
  );
};

enum StyleName {
  container = 'container',
  contentContainer = 'contentContainer'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    mt: '$6',
    paddingX: '$4'
  },
  contentContainer: {}
};
